import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { toast } from "sonner";

const CartContext = createContext(null);

export const GIFT_BOX_PRICE = 8;

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      const raw = JSON.parse(localStorage.getItem("locka_cart") || "[]");
      return raw.map((i) => ({ size: "M", ...i, key: i.key || `${i.product.id}:${i.size || "M"}` }));
    } catch {
      return [];
    }
  });
  const [open, setOpen] = useState(false);
  const [giftBox, setGiftBox] = useState(false);
  const [giftMessage, setGiftMessage] = useState("");

  useEffect(() => {
    localStorage.setItem("locka_cart", JSON.stringify(items));
  }, [items]);

  const add = (product, size = "M", quantity = 1) => {
    const key = `${product.id}:${size}`;
    setItems((prev) => {
      const found = prev.find((i) => i.key === key);
      if (found) {
        return prev.map((i) => (i.key === key ? { ...i, quantity: Math.min(i.quantity + quantity, 20) } : i));
      }
      return [...prev, { key, product, size, quantity }];
    });
    toast.success(`${product.name} · Size ${size} added`, { description: "Elegance, secured in your cart." });
  };

  const remove = (key) => setItems((prev) => prev.filter((i) => i.key !== key));
  const setQty = (key, quantity) =>
    setItems((prev) =>
      quantity <= 0 ? prev.filter((i) => i.key !== key) : prev.map((i) => (i.key === key ? { ...i, quantity } : i))
    );
  const clear = () => setItems([]);

  const value = useMemo(() => {
    const count = items.reduce((s, i) => s + i.quantity, 0);
    const total = items.reduce((s, i) => s + i.product.price * i.quantity, 0);
    return { items, add, remove, setQty, clear, count, total, open, setOpen, giftBox, setGiftBox, giftMessage, setGiftMessage };
  }, [items, open, giftBox, giftMessage]);

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
}

export const useCart = () => useContext(CartContext);
